import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ReactNode } from 'react';

interface PublicRouteProps {
    children: ReactNode;
}

// Ändere 'export const' zu 'export default'
const PublicRoute = ({ children }: PublicRouteProps) => {
    const { auth } = useAuth();

    if (auth.isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default PublicRoute;